var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupermarketIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#FFB017"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1396_5018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13C6.95 13 6.505 13.45 6.505 14C6.505 14.55 6.95 15 7.5 15C8.05 15 8.5 14.55 8.5 14C8.5 13.45 8.05 13 7.5 13ZM4.5 5.5C4.5 5.775 4.725 6 5 6H5.5L7.3 9.795L6.625 11.015C6.26 11.685 6.74 12.5 7.5 12.5H13C13.275 12.5 13.5 12.275 13.5 12C13.5 11.725 13.275 11.5 13 11.5H7.5L8.05 10.5H11.775C12.15 10.5 12.48 10.295 12.65 9.985L14.44 6.74C14.625 6.41 14.385 6 14.005 6H6.605L6.27 5.285C6.19 5.11 6.01 5 5.82 5H5C4.725 5 4.5 5.225 4.5 5.5ZM12.5 13C11.95 13 11.505 13.45 11.505 14C11.505 14.55 11.95 15 12.5 15C13.05 15 13.5 14.55 13.5 14C13.5 13.45 13.05 13 12.5 13Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1396_5018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupermarketIcon);
export default __webpack_public_path__ + "static/media/supermarket_icon.1622cf5d39c8e3dc9d6b475851839301.svg";
export { ForwardRef as ReactComponent };